<ng-container *ngIf="model.id">
  <h3 nxHeadline="subsection-large"
      class="nx-margin-bottom-s">{{model[titleProperty]}} {{'general.editEntity.'+modelType | caption}} {{'general.edit' | caption}}</h3>
</ng-container>
<ng-container *ngIf="!model.id">
  <h3 nxHeadline="subsection-large" class="nx-margin-bottom-s">{{'general.newEntity.'+modelType | caption}}</h3>
</ng-container>
